import * as Sentry from '@sentry/react';

import { MAP_GEOLOCATION_ZOOM } from '~/components/ModalDeliveryAddress/constants';
import { deliveryAddressStore } from '~/components/ModalDeliveryAddress/DeliveryAddressStore';
import { mainStore } from '~/stores/MainStore';

export const useGeolocation = () => {
  const requestLocation = () => {
    if (deliveryAddressStore.isActiveGeolocation) {
      deliveryAddressStore.setIsActiveGeolocation(false);
    } else {
      deliveryAddressStore.setIsAwaitGeolocation(true);
      deliveryAddressStore.setIsMapBusy(true);

      const options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      };

      if (mainStore.isRN) {
        mainStore.sendToRN(
          'getGeolocation',
          {
            target: 'findme_icon',
          },
          (e) => {
            if (
              !e ||
              !e.location?.coords?.latitude ||
              !e.location?.coords?.longitude
            ) {
              deliveryAddressStore.setIsMapBusy(false);
              deliveryAddressStore.setIsAwaitGeolocation(false);
              return;
            }
            deliveryAddressStore.setGeolocationCoordinates({
              lat: e.location.coords.latitude,
              lng: e.location.coords.longitude,
            });
            deliveryAddressStore.setMapZoom(MAP_GEOLOCATION_ZOOM);
            deliveryAddressStore.setIsActiveGeolocation(true);
            deliveryAddressStore.setIsMapBusy(false);
            deliveryAddressStore.setIsSmallSizeCover(true);
            deliveryAddressStore.setIsAwaitGeolocation(false);
          },
          (err) => {
            deliveryAddressStore.setIsActiveGeolocation(false);
            deliveryAddressStore.setGeolocationCoordinates(null);
            deliveryAddressStore.setIsAwaitGeolocation(false);
            deliveryAddressStore.setIsMapBusy(false);

            Sentry.withScope((scope) => {
              scope.setExtras({
                message: err.message || undefined,
                error: err,
              });
              Sentry.captureMessage('Auto Geolocation error', 'error');
            });
          },
        );
      } else {
        if (!navigator.geolocation) {
          deliveryAddressStore.setIsMapBusy(false);
          deliveryAddressStore.setIsAwaitGeolocation(false);
          return;
        }

        navigator.geolocation.getCurrentPosition(
          (e) => {
            if (!e || !e.coords?.latitude || !e.coords?.longitude) {
              deliveryAddressStore.setIsMapBusy(false);
              deliveryAddressStore.setIsAwaitGeolocation(false);
              return;
            }
            deliveryAddressStore.setGeolocationCoordinates({
              lat: e.coords.latitude,
              lng: e.coords.longitude,
            });
            deliveryAddressStore.setMapZoom(MAP_GEOLOCATION_ZOOM);
            deliveryAddressStore.setIsActiveGeolocation(true);
            deliveryAddressStore.setIsMapBusy(false);
            deliveryAddressStore.setIsSmallSizeCover(true);
            deliveryAddressStore.setIsAwaitGeolocation(false);
          },
          (err) => {
            /* eslint-disable no-console */
            console.log('Geolocation error: ' + err.message);
            deliveryAddressStore.setIsActiveGeolocation(false);
            deliveryAddressStore.setGeolocationCoordinates(null);
            deliveryAddressStore.setIsAwaitGeolocation(false);
            deliveryAddressStore.setIsMapBusy(false);

            Sentry.withScope((scope) => {
              scope.setExtras({
                message: err.message || undefined,
                error: err,
              });
              Sentry.captureMessage('Auto Geolocation error', 'error');
            });
          },
          options,
        );
      }
    }
    deliveryAddressStore.setIsManuallyInput(false);
    deliveryAddressStore.setInputAddressFocused(false);
  };
  return { requestLocation };
};
